import { domains, type environmentNames } from 'ui/config/constants';
import { getConfigString } from 'ui/util/getConfigString';

export interface ENVValues {
  app_env: environmentNames,
  app_url: string,
  api_url: string,
  stripe_kamino: string,
  g_maps_key: string,
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getConfig = (allEnv: any) => {
  const appEnv = getConfigString('app_env', allEnv) as environmentNames;
  const config = {
    env: appEnv,
    domains: domains[appEnv],
    appURL: domains[appEnv].members,
    api: domains[appEnv].api,
    stripe_kamino: getConfigString('stripe_kamino', allEnv),
    is: {
      local: appEnv === 'local',
      qa: appEnv === 'quality-assurance',
      uat: appEnv === 'user-acceptance-testing',
      prod: appEnv === 'production',
    },
    gMapsKey: getConfigString('g_maps_key', allEnv),
  };
  return config;
};
